import * as React from 'react'
import styled, { css } from 'styled-components'
import { ConversationMessage, ConversationMessageAuthorType, ConversationMessageType, PublicLocale } from '../../../../types'
import moment from '../../../../utilities/Moment'
import { useTranslation } from 'react-i18next'
import MessageContent from '../../MessageContent'


const AvatarContainer = styled.div`
  position: absolute;
  left: 0px;
  bottom: 10px;
`

const MessageMetadata = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-size: 13px;
  justify-content: flex-end;
  margin-top: 6px;
`

const MessageContainer = styled.div`
  padding: 12px 16px;
  border-radius: 20px;
  position: relative;
  display: inline-block;
  width: auto;
  max-width: 75%;
  color: rgb(0, 0, 0);
  background-color: rgb(242, 242, 242);
  word-break: break-word;
  overflow-wrap: break-word;

  a {
    color: rgb(0, 0, 0);
    text-decoration: underline;
  }

  img {
    width: 100%;
    max-width: 100%;
  }
`

const Container = styled.div<{
  sender: boolean,
  type: ConversationMessageType,
  topRadius: boolean,
  bottomRadius: boolean
}>`
  position: relative;
  text-align: left;
  float: left;
  width: calc(100% - 45px);

  ${props => !props.sender && css`
    ${MessageContainer} {
      color: black;

      ${props.topRadius && css`
        border-top-left-radius: 4px;
      `}

      ${props.bottomRadius && css`
        border-bottom-left-radius: 4px;
      `}

      a {
        color: black !important;
      }
    }

    ${MessageMetadata} {
      justify-content: flex-end;
    }

    ${AvatarContainer} {
      display: none;
    }
  `}


  ${props => props.sender && css`
    float: right;

    ${MessageContainer} {
      background: ${({ theme }) => theme.color.background};
      color: ${({ theme }) => theme.color.backgroundText};
      float: right;

      ${props.topRadius && css`
        border-top-right-radius: 4px;
      `}

      ${props.bottomRadius && css`
        border-bottom-right-radius: 4px;
      `}

      a {
        color: ${({ theme }) => theme.color.backgroundText} !important;
      }
    }

    ${MessageMetadata} {
      justify-content: flex-end;
    }

    ${AvatarContainer} {
      display: none;
    }
  `}

  ${props => props.type === ConversationMessageType.REQUEST_EMAIL && css`
    width: 100%;

    ${MessageContainer} {
      width: 100%;
      max-width: 100%;
      padding-right: 0;
      padding-left: 0;
      background: transparent;
      color: ${({ theme }) => theme.color.backgroundText};
    }
  `}

  ${props => props.type === ConversationMessageType.NOTE && css`
    ${MessageContainer} {
      background: #feecaf;
      color: black;
    }
  `}
`

interface IProps {
  message: ConversationMessage
  onPreviewClick: (url: string) => void
  admin?: boolean
  topRadius?: boolean
  bottomRadius?: boolean
  locale: PublicLocale
}

const Message = (props: IProps) => {
  const { message, onPreviewClick, admin, topRadius, bottomRadius, locale } = props
  const { t } = useTranslation()
  const sender = (admin && message?.author?.type === ConversationMessageAuthorType.USER) || (!admin && (message?.author?.type === ConversationMessageAuthorType.CONTACT || message?.author === null))

  return (
    <Container
      type={message.type}
      sender={sender}
      topRadius={topRadius}
      bottomRadius={bottomRadius}
    >
      <MessageContainer>
        <MessageContent
          message={message}
          onPreviewClick={onPreviewClick}
          admin={admin}
        />
        {false && message.created_at && <MessageMetadata>
          {moment(message.created_at).format('HH:mm')}
        </MessageMetadata>}
      </MessageContainer>
    </Container >
  )
}

export default Message